import cx from 'classnames'
import { useEffect, useRef } from 'react'
import { useIntl } from 'react-intl'
import { Outlet } from 'react-router'

import Footer from '../../Footer/Footer'
import Header from '../../Header/Header'
import { useContentHeader } from '../../Header/hooks/useContentHeader'

import hocAppLayout from './hocAppLayout'

import LoaderPopup from 'components/Loader/LoaderPopup/LoaderPopup'
import CinemaSelectWindow from 'components/Modal/CinemaSelectWindow/CinemaSelectWindow'
import DocumentPopUp from 'components/Modal/DocumentPopupWindow/DocumentPopUp'
import MessagesList from 'components/Windows/CentralMessagesList/MessagesList'
import { scrollToTop } from '../../../global/helpers'
import FormGoPay from '../../Forms/FormGoPay/FormGoPay'
import './AppLayout.scss'

const AppLayout = ({ withoutApp, formOpen, cinemaSelectionRequired }) => {
    const intl = useIntl()
    const bodyRef = useRef(document.body)
    const { openedChooseCinema, openedMenu, toggleChooseCineama, toggleMenu, handleClose, handleClickProgram } =
        useContentHeader()

    const isOpen = openedMenu || openedChooseCinema
    const scrollLocked = isOpen || cinemaSelectionRequired

    const chosenCinema = localStorage.getItem('site')
    const cinemaid = localStorage.getItem('cinemaid')

    useEffect(() => {
        if (scrollLocked) {
            bodyRef.current.style.overflow = 'hidden'
        } else {
            bodyRef.current.style.overflow = 'auto'
        }
    }, [scrollLocked])

    useEffect(() => {
        if (formOpen) {
            scrollToTop()
        }
    }, [formOpen])

    if (withoutApp)
        return (
            <div className="app-layout" style={{ width: '100vw', height: '100vh' }}>
                <div className="app-layout-content" style={{ height: '100%' }}>
                    <Outlet />
                </div>
            </div>
        )

    return (
        <div className={cx('app-layout', formOpen && 'form-active')}>
            <FormGoPay />
            <LoaderPopup />
            <MessagesList />

            <Header
                openedChooseCinema={openedChooseCinema}
                openedMenu={openedMenu}
                toggleChooseCineama={toggleChooseCineama}
                toggleMenu={toggleMenu}
                handleClickProgram={handleClickProgram}
                chosenCinema={chosenCinema}
                cinemaid={cinemaid}
            />
            <div className={`app-layout--content`}>
                <Outlet />
            </div>
            <Footer toggleChooseCineama={toggleChooseCineama} chosenCinema={chosenCinema} />
            {isOpen && <div className="app-layout--blur" onClick={handleClose} />}
            <DocumentPopUp />
            <CinemaSelectWindow />
        </div>
    )
}

export default hocAppLayout(AppLayout)
